import { getFormattedDate } from "utils/formatDate";

const ProfileTransactionsAdditional = ({ columns }) => {

  const getEmptyElements = (length) => {
    const MAX_COLUMNS_LENGTH = 7;

    if (length < MAX_COLUMNS_LENGTH) {
      const emptyColumns = [...new Array(MAX_COLUMNS_LENGTH - length)];

      return emptyColumns.map((_, index) => (
        <li
          key={`empty-col-${index}`}
          className={`profile__table-col profile__table-col${columns.length + index + 1}`}
        ></li>
      ));
    }

    return null;
  };

  return (
    <li className="profile__table-col--max">
      <ul>
        {columns.map((col, index) => {
          const { column_name, column_value } = col;

          return (
            <li className={`profile__table-col profile__table-col${index + 1}`}>
              <span>{column_name}</span>
              {column_value.includes('UTC') ? getFormattedDate(column_value) : column_value}
            </li>
          );
        })}
        {getEmptyElements(columns.length)}
      </ul>
    </li>
  );
};

export default ProfileTransactionsAdditional;
